import { supabase } from '../lib/supabase';
import { generateAutoDescription } from './forumDescriptionGenerator';

// SEO dostu forum açıklamaları
const forumDescriptions: Record<string, string> = {
  // Teknoloji Forumları
  'technopat': 'Türkiye\'nin en büyük teknoloji topluluğu. Donanım incelemeleri, yazılım rehberleri ve teknoloji haberlerinde uzman görüşleri. 500.000+ üye ile PC, mobil ve oyun teknolojilerinde aktif tartışmalar.',
  'donanimhaber': 'Donanım ve teknoloji dünyasının nabzını tutan forum. PC toplama rehberleri, donanım testleri ve teknoloji incelemeleri. Uzman kullanıcılardan profesyonel tavsiyeler ve güncel teknoloji haberleri.',
  'chip': 'Bilgisayar ve teknoloji meraklılarının buluşma noktası. Donanım sorunları çözümleri, yazılım önerileri ve teknoloji tartışmaları. Teknik destek ve uzman tavsiyeleri için ideal platform.',
  'ituforum': 'İTÜ öğrenci ve mezunlarının akademik ve teknoloji odaklı tartışma platformu. Mühendislik, bilim ve teknoloji konularında derinlemesine analizler. Üniversite yaşamı ve kariyer rehberleri.',
  'mobilhanem': 'Mobil teknoloji ve akıllı telefon dünyasının rehberi. Android, iOS, tablet incelemeleri ve mobil uygulama önerileri. Güncel mobil teknoloji haberleri ve kullanım ipuçları.',
  'shiftdelete': 'Teknoloji haberleri ve ürün incelemeleri platformu. Gadget testleri, yazılım analizleri ve teknoloji trendleri. Güncel teknoloji dünyasından haberler ve derinlemesine incelemeler.',
  'webmaster': 'Web tasarım ve geliştirme topluluğu. HTML, CSS, JavaScript ve web teknolojileri üzerine teknik tartışmalar. Web geliştiriciler için kaynak paylaşımı ve proje örnekleri.',
  'programlama': 'Yazılım geliştiricilerin bilgi paylaşım platformu. Programlama dilleri, algoritma çözümleri ve yazılım geliştirme süreçleri. Kod örnekleri ve teknik problemlerin çözümleri.',
  'linux': 'Linux ve açık kaynak yazılım topluluğu. Sistem yönetimi, dağıtım incelemeleri ve teknik destek. Ubuntu, CentOS, Debian gibi dağıtımlar için rehberler ve sorun çözümleri.',
  'apple': 'Apple ürünleri kullanıcılarının buluşma noktası. iPhone, iPad, Mac incelemeleri ve kullanım ipuçları. iOS güncellemeleri, uygulama önerileri ve Apple ekosistemi rehberleri.',
  'samsung': 'Samsung teknoloji ürünleri topluluğu. Galaxy serisi akıllı telefonlar, tablet incelemeleri ve Samsung ekosistemi. Güncellemeler, özelleştirme ipuçları ve teknik destek.',
  'xiaomi': 'Xiaomi kullanıcıları ve teknoloji tutkunlarının platformu. MIUI incelemeleri, ROM geliştirme ve Xiaomi ürün testleri. Fiyat-performans odaklı teknoloji tartışmaları.',

  // Oyun Forumları
  'oyunfor': 'Türk oyuncuların en büyük buluşma noktası. PC, konsol ve mobil oyun incelemeleri, rehberleri ve topluluk etkinlikleri. Oyun haberleri, indirim fırsatları ve oyuncu buluşmaları.',
  'gameturk': 'Oyun dünyasının her türlü haberini ve incelemesini bulabileceğiniz kapsamlı platform. Oyuncu topluluğu ile interaktif deneyim, turnuvalar ve oyun etkinlikleri.',
  'mmocenter': 'MMORPG ve online oyun tutkunlarının merkezi. World of Warcraft, Guild Wars ve diğer MMO oyunları için rehberler, guild organizasyonları ve oyuncu buluşmaları.',
  'lolturk': 'League of Legends Türkiye topluluğu. Şampiyon rehberleri, strateji analizleri, turnuva haberleri ve oyuncu eşleştirmeleri. LoL Türkiye liginden güncel haberler.',
  'valorantturk': 'Valorant Türkiye oyuncu topluluğu. Agent rehberleri, strateji analizleri ve turnuva haberleri. Valorant Champions Tour ve yerel turnuva organizasyonları.',
  'csgoturk': 'Counter-Strike: Global Offensive Türkiye topluluğu. Taktik analizleri, silah rehberleri ve turnuva haberleri. CS:GO Türkiye sahnesinden güncel gelişmeler.',

  // Spor Forumları
  'mackolik': 'Türkiye\'nin en büyük spor topluluğu. Futbol, basketbol ve diğer spor dallarında canlı tartışmalar ve analizler. Maç özetleri, transfer haberleri ve spor yorumları.',
  'sporx': 'Spor tutkunlarının buluşma noktası. Maç analizleri, transfer haberleri ve spor yorumları. Tüm spor dallarından güncel haberler ve uzman analizleri.',
  'fanatik': 'Futbol ve spor dünyasının nabzını tutan platform. Takım taraftarları arası tartışmalar, maç analizleri ve spor haberleri. Süper Lig ve Avrupa liglerinden güncel gelişmeler.',
  'besiktas': 'Beşiktaş taraftarlarının resmi olmayan buluşma platformu. Maç analizleri, transfer haberleri ve taraftar etkinlikleri. Siyah-beyazlı tutkuyla dolu tartışmalar.',
  'galatasaray': 'Galatasaray topluluğunun tartışma merkezi. Takım haberleri, oyuncu analizleri ve sarı-kırmızı tutkusu. Cimbom\'un her maçından detaylı analizler.',
  'fenerbahce': 'Fenerbahçe taraftarlarının sosyal platformu. Maç yorumları, takım haberleri ve taraftar organizasyonları. Sarı-lacivertli camiadan güncel gelişmeler.',

  // Eğitim Forumları
  'uludagsozluk': 'Türkiye\'nin en eski ve köklü sözlük platformu. Gündem, kültür, sanat ve yaşam üzerine özgün yazılar ve tartışmalar. Entelektüel sohbet ve bilgi paylaşımı.',
  'eksisozluk': 'Türkiye\'nin en popüler sözlük sitesi. Güncel olaylar, kültür, sanat ve yaşamın her alanından entry\'ler ve tartışmalar. Sosyal medya öncesi topluluk deneyimi.',
  'itusozluk': 'İTÜ öğrenci ve mezunlarının akademik ve sosyal paylaşım platformu. Üniversite yaşamı, kariyer tavsiyeleri ve teknoloji odaklı içerikler.',
  'lgs': 'LGS sınavına hazırlanan öğrenciler için destek platformu. Soru çözümleri, deneme sınavları ve motivasyon desteği. Lise geçiş sınavı hazırlık rehberleri.',
  'yks': 'YKS ve üniversite sınavları hazırlık merkezi. Ders programları, soru bankası önerileri ve sınav stratejileri. Üniversite tercih rehberleri ve başarı hikayeleri.',
  'kpss': 'KPSS ve kamu personel sınavları hazırlık merkezi. Ders notları, soru çözümleri ve başarı hikayeleri. Kamu sınavları için kapsamlı hazırlık materyalleri.',

  // Sağlık Forumları
  'saglikforumu': 'Sağlık konularında güvenilir bilgi paylaşım platformu. Uzman doktor görüşleri, hastalık bilgileri ve sağlık tavsiyeleri. Tıbbi konularda bilinçli tartışmalar.',
  'anneyiz': 'Anne ve bebek sağlığı odaklı topluluk. Hamilelik, doğum ve çocuk bakımı konularında deneyim paylaşımları. Annelik deneyimleri ve uzman tavsiyeleri.',
  'diyet': 'Sağlıklı yaşam ve beslenme rehberi. Diyet programları, fitness tavsiyeleri ve kilo verme deneyimleri. Beslenme uzmanlarından profesyonel tavsiyeler.',
  'diabet': 'Diyabet hastaları ve yakınları için bilgi paylaşım platformu. Beslenme tavsiyeleri, tedavi deneyimleri ve uzman görüşleri. Diyabet yönetimi rehberleri.',
  'kalp': 'Kalp sağlığı ve kardiyovasküler hastalıklar bilgi merkezi. Önleme yöntemleri, tedavi seçenekleri ve yaşam tarzı önerileri. Kalp sağlığı farkındalığı.',

  // Otomotiv Forumları
  'garageturk': 'Otomobil tutkunlarının teknik bilgi paylaşım merkezi. Araba bakımı, modifikasyon rehberleri ve otomotiv teknolojileri. Klasik ve modern araç incelemeleri.',
  'otomobilim': 'Otomobil sahipleri için kapsamlı bilgi platformu. Araç incelemeleri, bakım tavsiyeleri ve satış-alım rehberleri. Otomotiv sektöründen güncel haberler.',
  'arabam': 'Türkiye\'nin en büyük otomobil topluluğu. İkinci el araç değerlendirmeleri, teknik destek ve otomotiv haberleri. Araç alım-satım tavsiyeleri ve pazar analizleri.',

  // Hobi ve İlgi Alanları
  'fotografya': 'Fotoğraf sanatı ve teknik bilgi paylaşım merkezi. Ekipman incelemeleri, çekim teknikleri ve fotoğraf yarışmaları. Profesyonel ve amatör fotoğrafçılar için rehberler.',
  'muzikforumu': 'Müzik tutkunlarının buluşma noktası. Enstrüman eğitimi, müzik teorisi ve sanatçı tartışmaları. Müzik prodüksiyonu ve kayıt teknikleri rehberleri.',
  'kitapkurdu': 'Kitap severler için kapsamlı platform. Kitap incelemeleri, yazar röportajları ve okuma önerileri. Edebiyat tartışmaları ve kitap kulübü etkinlikleri.',
  'balik': 'Balık tutma ve su ürünleri hobi platformu. Avlama teknikleri, ekipman incelemeleri ve balık türleri rehberi. Balıkçılık meraklıları için lokasyon önerileri.',
  'kamp': 'Kamp ve doğa sporları tutkunlarının buluşma noktası. Kamp alanları rehberi, ekipman tavsiyeleri ve doğa deneyimleri. Outdoor aktiviteler için kapsamlı bilgiler.',
  'bisiklet': 'Bisiklet sporları ve bisiklet tutkunları topluluğu. Rota önerileri, bisiklet bakımı ve cycling etkinlikleri. Bisiklet turları ve yarış organizasyonları.',

  // Finans ve Ekonomi
  'yatirimforum': 'Yatırım ve finans dünyasının rehberi. Borsa analizleri, ekonomi yorumları ve yatırım stratejileri. Hisse senedi, döviz ve kripto para tartışmaları.',
  'dolarforum': 'Döviz ve ekonomi takipçilerinin platformu. Güncel kurlar, ekonomik analizler ve yatırım tavsiyeleri. Forex piyasası ve döviz stratejileri.',
  'borsaforum': 'Borsa yatırımcıları için teknik analiz ve strateji platformu. Hisse senedi analizleri, portföy yönetimi ve piyasa yorumları. BIST ve global piyasa takibi.',

  // Ev ve Yaşam
  'evdekorasyonu': 'Ev dekorasyonu ve tasarım ilhamı merkezi. DIY projeleri, dekorasyon fikirleri ve ev düzenleme tavsiyeleri. İç mimarlık trendleri ve yaratıcı çözümler.',
  'bahcecilik': 'Bahçıvanlık ve bitki bakımı rehberi. Sebze yetiştirme, çiçek bakımı ve peyzaj tasarımı. Organik tarım teknikleri ve bahçe düzenleme önerileri.',
  'yemektarifleri': 'Yemek tarifleri ve mutfak kültürü platformu. Geleneksel ve modern tarifler, pişirme teknikleri ve mutfak ipuçları. Dünya mutfaklarından lezzetler.',

  // Sanat ve Kültür
  'sanatforumu': 'Sanat ve kültür dünyasının tartışma platformu. Resim, heykel, edebiyat ve sahne sanatları üzerine derinlemesine analizler. Sanat etkinlikleri ve sergi haberleri.',
  'sinema': 'Film tutkunlarının buluşma noktası. Film incelemeleri, yönetmen analizleri ve sinema haberleri. Türk ve dünya sinemasından güncel gelişmeler.',
  'tiyatro': 'Tiyatro sanatı ve sahne performansları platformu. Oyun incelemeleri, oyuncu analizleri ve tiyatro haberleri. Sahne sanatları etkinlikleri ve festival duyuruları.',

  // Seyahat ve Turizm
  'gezginler': 'Seyahat tutkunlarının deneyim paylaşım merkezi. Gezi rehberleri, otel tavsiyeleri ve seyahat ipuçları. Dünya destinasyonları ve kültürel deneyimler.',
  'tatilbudur': 'Tatil planlama ve seyahat önerileri platformu. Destinasyon rehberleri, konaklama tavsiyeleri ve seyahat deneyimleri. Bütçe dostu tatil önerileri.',
  'backpacker': 'Sırt çantalı seyahat ve macera tutkunları topluluğu. Ekonomik seyahat rehberleri, hostel önerileri ve solo seyahat deneyimleri.',

  // İş ve Kariyer
  'kariyernet': 'Kariyer gelişimi ve iş arama platformu. CV hazırlama rehberleri, mülakat teknikleri ve sektörel kariyer tavsiyeleri. Profesyonel gelişim önerileri.',
  'isarayan': 'İş arayanlar ve işverenler için buluşma noktası. İş ilanları, kariyer fırsatları ve mesleki gelişim. Sektörel iş piyasası analizleri.',
  'girisimci': 'Girişimcilik ve iş kurma rehberi. Startup önerileri, iş planı hazırlama ve finansman kaynakları. Girişimci deneyimleri ve başarı hikayeleri.',

  // Alışveriş ve Tüketici
  'cimri': 'Akıllı alışveriş ve fiyat karşılaştırma topluluğu. Ürün incelemeleri, indirim fırsatları ve tüketici deneyimleri. En iyi fiyat garantisi ve alışveriş tavsiyeleri.',
  'kampanyalar': 'İndirim ve kampanya takip platformu. Güncel fırsatlar, kupon kodları ve alışveriş önerileri. Online ve offline mağaza kampanyaları.',

  // Eğlence ve Sosyal
  'caps': 'Mizah ve eğlence içerikleri platformu. Komik görseller, viral içerikler ve sosyal medya trendleri. Türk internet kültürü ve mizah paylaşımları.',
  'uykusuzlar': 'Gece kuşlarının sosyal buluşma platformu. Sohbet odaları, oyun turnuvaları ve eğlence odaklı topluluk aktiviteleri. 7/24 aktif sosyal ortam.',
  'komedi': 'Stand-up komedi ve mizah sanatları platformu. Komedyen incelemeleri, gösteri duyuruları ve mizah yazıları. Türk komedi sahnesinden haberler.',

  // Bölgesel ve Yerel
  'istanbulforumu': 'İstanbul yaşamı ve şehir rehberi. Mekan önerileri, etkinlik duyuruları ve şehir yaşamı deneyimleri. İstanbul\'un kültürel ve sosyal yaşamı.',
  'ankaraforumu': 'Ankara\'da yaşayanlar için yerel bilgi paylaşım platformu. Şehir haberleri, etkinlikler ve sosyal aktiviteler. Başkent yaşamından güncel gelişmeler.',
  'izmirforumu': 'İzmir ve Ege bölgesi yaşam rehberi. Yerel haberler, kültürel etkinlikler ve şehir yaşamı. Ege kültürü ve İzmir yaşam tarzı.',

  // Özel İlgi Alanları
  'astronomi': 'Astronomi ve uzay bilimleri meraklılarının platformu. Gözlem teknikleri, uzay haberleri ve bilimsel tartışmalar. Teleskop incelemeleri ve gök olayları takibi.',
  'tarih': 'Tarih meraklılarının bilgi paylaşım merkezi. Tarihsel olaylar, arkeoloji haberleri ve tarih araştırmaları. Türk ve dünya tarihinden derinlemesine analizler.',
  'felsefe': 'Felsefe ve düşünce dünyası tartışma platformu. Felsefi akımlar, düşünür analizleri ve entelektüel sohbetler. Felsefe eğitimi ve kitap önerileri.',
  'psikoloji': 'Psikoloji bilimi ve mental sağlık platformu. Psikolojik teoriler, terapi yöntemleri ve mental sağlık farkındalığı. Uzman görüşleri ve kişisel gelişim.',

  // Moda ve Güzellik
  'moda': 'Moda trendleri ve stil rehberi. Giyim önerileri, marka incelemeleri ve moda haberleri. Sezon trendleri ve stil tavsiyeleri.',
  'guzellik': 'Güzellik ve bakım ürünleri platformu. Kozmetik incelemeleri, cilt bakımı ve makyaj teknikleri. Güzellik uzmanlarından profesyonel tavsiyeler.',

  // Evcil Hayvanlar
  'kopek': 'Köpek sahipleri ve köpek severlerin platformu. Köpek bakımı, eğitimi ve sağlık bilgileri. Köpek ırkları rehberi ve veteriner tavsiyeleri.',
  'kedi': 'Kedi sahipleri topluluğu. Kedi bakımı, beslenme ve sağlık konuları. Kedi davranışları analizi ve veteriner önerileri.',
  'akvaryum': 'Akvaryum hobi ve balık bakımı platformu. Akvaryum kurulumu, balık türleri ve su kimyası. Tropik balık bakımı ve akvaryum dekorasyonu.',

  // Din ve Maneviyat
  'diniforum': 'Dini konular ve maneviyat tartışma platformu. İslami bilgiler, dini sorular ve cevaplar. Dini eğitim ve maneviyat rehberleri.',
  'hadis': 'Hadis ilimleri ve İslami araştırmalar platformu. Hadis incelemeleri, İslami kaynaklar ve dini araştırmalar. İslam tarihi ve fıkıh konuları.',

  // Bilim ve Teknoloji
  'bilim': 'Bilim ve araştırma platformu. Bilimsel makaleler, araştırma sonuçları ve bilim haberleri. Fizik, kimya, biyoloji ve matematik konuları.',
  'matematik': 'Matematik meraklıları ve öğrenciler için platform. Matematik problemleri, çözüm teknikleri ve matematik eğitimi. Üniversite ve lise matematik desteği.',

  // Müzik ve Enstrümanlar
  'gitar': 'Gitar çalma ve müzik eğitimi platformu. Gitar dersleri, akor rehberleri ve şarkı çalma teknikleri. Elektro ve akustik gitar incelemeleri.',
  'piyano': 'Piyano eğitimi ve klasik müzik platformu. Piyano dersleri, nota okuma ve müzik teorisi. Klasik ve modern piyano eserleri.',

  // Spor Alt Kategorileri
  'fitness': 'Fitness ve vücut geliştirme topluluğu. Antrenman programları, beslenme tavsiyeleri ve supplement rehberleri. Spor salonu deneyimleri ve fitness ipuçları.',
  'yuzme': 'Yüzme sporu ve su sporları platformu. Yüzme teknikleri, antrenman programları ve yarış haberleri. Su sporları ekipmanları ve havuz önerileri.',
  'tenis': 'Tenis sporu ve raket sporları topluluğu. Tenis teknikleri, turnuva haberleri ve ekipman incelemeleri. Tenis kortları ve antrenör önerileri.',

  // Teknoloji Alt Kategorileri
  'android': 'Android işletim sistemi ve uygulama geliştirme platformu. Android güncellemeleri, uygulama incelemeleri ve özelleştirme rehberleri.',
  'ios': 'iOS ve iPhone kullanıcıları topluluğu. iOS güncellemeleri, uygulama önerileri ve iPhone kullanım ipuçları. Apple ekosistemi rehberleri.',
  'windows': 'Windows işletim sistemi kullanıcıları platformu. Windows güncellemeleri, sorun çözümleri ve sistem optimizasyonu. PC kullanım rehberleri.',

  // Eğitim Alt Kategorileri
  'fizik': 'Fizik bilimi ve eğitim platformu. Fizik konuları, deney rehberleri ve bilimsel araştırmalar. Lise ve üniversite fizik desteği.',
  'kimya': 'Kimya bilimi ve laboratuvar deneyimleri. Kimya konuları, deney protokolleri ve kimya eğitimi. Organik ve inorganik kimya rehberleri.',

  // Sanat Alt Kategorileri
  'resim': 'Resim sanatı ve çizim teknikleri platformu. Resim dersleri, malzeme incelemeleri ve sanat teknikleri. Dijital ve geleneksel resim rehberleri.',
  'heykel': 'Heykel sanatı ve üç boyutlu tasarım platformu. Heykel teknikleri, malzeme kullanımı ve sanat projeleri. Çağdaş heykel sanatı tartışmaları.',

  // Yemek ve Mutfak
  'ascilik': 'Profesyonel mutfak ve aşçılık platformu. Yemek tarifleri, mutfak teknikleri ve gastronomi. Restoran deneyimleri ve mutfak ekipmanları.',
  'tatli': 'Tatlı tarifleri ve pastane sanatları. Pasta yapımı, tatlı teknikleri ve dekorasyon önerileri. Geleneksel ve modern tatlı tarifleri.',

  // Doğa ve Çevre
  'doga': 'Doğa severleri ve çevre bilinci platformu. Doğa fotoğrafçılığı, ekoloji ve çevre koruma. Doğa yürüyüşleri ve outdoor aktiviteler.',
  'cevre': 'Çevre koruma ve sürdürülebilirlik platformu. Çevre sorunları, geri dönüşüm ve yeşil yaşam. Ekolojik farkındalık ve çevre projeleri.',

  // Teknoloji Markaları
  'huawei': 'Huawei teknoloji ürünleri kullanıcı topluluğu. Huawei telefon incelemeleri, EMUI güncellemeleri ve kullanım ipuçları.',
  'oppo': 'OPPO akıllı telefon kullanıcıları platformu. ColorOS incelemeleri, kamera teknikleri ve OPPO ürün testleri.',
  'vivo': 'Vivo smartphone kullanıcıları topluluğu. Funtouch OS rehberleri, kamera özellikleri ve Vivo ürün incelemeleri.',

  // Sosyal Medya ve İletişim
  'instagram': 'Instagram kullanım rehberleri ve sosyal medya stratejileri. İçerik üretimi, hashtag stratejileri ve Instagram pazarlama.',
  'youtube': 'YouTube içerik üretimi ve video editörlüğü platformu. Video çekimi, montaj teknikleri ve YouTube kanalı büyütme stratejileri.',
  'tiktok': 'TikTok içerik üretimi ve trend takibi. Viral video teknikleri, TikTok algoritması ve sosyal medya trendleri.',

  // E-ticaret ve Pazarlama
  'eticaret': 'E-ticaret ve online satış platformu. Online mağaza kurma, dijital pazarlama ve e-ticaret stratejileri. Satış teknikleri ve müşteri deneyimi.',
  'pazarlama': 'Dijital pazarlama ve reklam stratejileri. SEO, sosyal medya pazarlama ve içerik pazarlama. Marka yönetimi ve müşteri ilişkileri.',

  // Kripto Para ve Blockchain
  'bitcoin': 'Bitcoin ve kripto para topluluğu. Blockchain teknolojisi, kripto para yatırımları ve mining rehberleri. Kripto para piyasa analizleri.',
  'ethereum': 'Ethereum ve akıllı kontratlar platformu. DeFi projeleri, NFT pazarı ve Ethereum ekosistemi. Blockchain geliştirme rehberleri.',

  // Freelance ve Uzaktan Çalışma
  'freelance': 'Freelance çalışma ve serbest meslek platformu. Proje yönetimi, müşteri ilişkileri ve freelance iş bulma. Uzaktan çalışma deneyimleri.',
  'uzaktancalisma': 'Uzaktan çalışma ve dijital nomadlık. Home office kurulumu, verimlilik ipuçları ve uzaktan çalışma araçları.',

  // Emlak ve İnşaat
  'emlak': 'Emlak yatırımları ve gayrimenkul platformu. Ev alım-satım, kira piyasası ve emlak yatırım tavsiyeleri. İnşaat sektörü haberleri.',
  'insaat': 'İnşaat mühendisliği ve yapı teknolojileri. İnşaat projeleri, malzeme incelemeleri ve yapı teknikler. Mimarlık ve tasarım önerileri.',

  // Hukuk ve Mevzuat
  'hukuk': 'Hukuki bilgiler ve mevzuat platformu. Yasal danışmanlık, hukuki süreçler ve mevzuat güncellemeleri. Avukat tavsiyeleri ve hukuki rehberler.',
  'vergi': 'Vergi mevzuatı ve muhasebe platformu. Vergi hesaplamaları, mevzuat değişiklikleri ve muhasebe rehberleri. Mali müşavir tavsiyeleri.',

  // Tarım ve Hayvancılık
  'tarim': 'Tarım ve hayvancılık platformu. Tarımsal üretim teknikleri, hayvancılık rehberleri ve tarım makineleri. Organik tarım ve sürdürülebilir üretim.',
  'hayvancilik': 'Hayvancılık ve veterinerlik platformu. Hayvan bakımı, beslenme rehberleri ve veteriner tavsiyeleri. Çiftlik hayvanları ve pet bakımı.',

  // Enerji ve Çevre
  'enerji': 'Enerji teknolojileri ve yenilenebilir enerji platformu. Solar enerji, rüzgar enerjisi ve enerji verimliliği. Sürdürülebilir enerji çözümleri.',
  'solar': 'Güneş enerjisi ve fotovoltaik sistemler. Solar panel kurulumu, enerji hesaplamaları ve güneş enerjisi yatırımları.',

  // Ulaşım ve Lojistik
  'ulasim': 'Ulaşım sistemleri ve toplu taşıma platformu. Şehir içi ulaşım, trafik çözümleri ve ulaşım politikaları. Akıllı ulaşım sistemleri.',
  'lojistik': 'Lojistik ve kargo hizmetleri platformu. Nakliye çözümleri, depo yönetimi ve lojistik optimizasyonu. E-ticaret lojistiği.',

  // Turizm Alt Kategorileri
  'otel': 'Otel incelemeleri ve konaklama rehberi. Otel rezervasyonları, konaklama deneyimleri ve seyahat tavsiyeleri. Butik oteller ve tatil köyleri.',
  'restoran': 'Restoran incelemeleri ve yemek kültürü. Gastronomi rehberleri, şef tavsiyeleri ve mutfak kültürü. Yerel lezzetler ve dünya mutfakları.',

  // Sağlık Alt Kategorileri
  'dis': 'Diş sağlığı ve ağız bakımı platformu. Diş hekimliği, ortodonti ve ağız sağlığı. Diş bakım önerileri ve tedavi yöntemleri.',
  'goz': 'Göz sağlığı ve görme bozuklukları platformu. Göz hastalıkları, lens kullanımı ve göz bakımı. Oftalmoloji ve görme sağlığı.',

  // Hobi Alt Kategorileri
  'koleksiyon': 'Koleksiyonculuk ve antika platformu. Pul, para, kartpostal koleksiyonculuğu. Antika eşya incelemeleri ve koleksiyon tavsiyeleri.',
  'elisi': 'El işleri ve zanaat sanatları platformu. Örgü, nakış, dikiş teknikleri ve yaratıcı projeler. Geleneksel el sanatları rehberleri.',

  // Bilim Alt Kategorileri
  'biyoloji': 'Biyoloji bilimi ve yaşam bilimleri platformu. Genetik, ekoloji ve moleküler biyoloji. Biyoloji eğitimi ve araştırma projeleri.',
  'cografi': 'Coğrafya ve yer bilimleri platformu. Fiziki coğrafya, beşeri coğrafya ve haritacılık. Coğrafi keşifler ve iklim değişikliği.',

  // Dil ve Edebiyat
  'edebiyat': 'Edebiyat ve yazın sanatları platformu. Şiir, roman, hikaye incelemeleri ve yazar analizleri. Türk ve dünya edebiyatı tartışmaları.',
  'ingilizce': 'İngilizce öğrenme ve dil eğitimi platformu. Gramer rehberleri, kelime öğrenme ve konuşma pratiği. TOEFL, IELTS sınav hazırlığı.',

  // Mesleki Eğitim
  'muhendislik': 'Mühendislik eğitimi ve teknik bilimler platformu. Makine, elektrik, bilgisayar mühendisliği. Mühendislik projeleri ve kariyer rehberleri.',
  'tip': 'Tıp eğitimi ve sağlık bilimleri platformu. Tıp fakültesi deneyimleri, uzmanlık sınavları ve tıbbi araştırmalar. Sağlık profesyonelleri topluluğu.',

  // Kültür ve Gelenek
  'kultur': 'Türk kültürü ve gelenekleri platformu. Halk oyunları, türküler ve geleneksel sanatlar. Kültürel miras koruma ve folklor araştırmaları.',
  'tarihiturk': 'Türk tarihi ve medeniyeti platformu. Osmanlı tarihi, Selçuklu dönemi ve Türk-İslam medeniyeti. Tarihsel araştırmalar ve belge incelemeleri.',

  // Alternatif Yaşam
  'minimalizm': 'Minimalist yaşam tarzı ve sade yaşam platformu. Minimalizm felsefesi, ev düzenleme ve tüketim alışkanlıkları. Sürdürülebilir yaşam önerileri.',
  'vegan': 'Vegan yaşam tarzı ve bitkisel beslenme platformu. Vegan tarifler, beslenme rehberleri ve etik tüketim. Hayvan hakları ve çevre bilinci.',

  // Teknoloji Girişimcilik
  'startup': 'Startup ekosistemi ve girişimcilik platformu. İş modelleri, yatırım alma ve ürün geliştirme. Teknoloji girişimleri ve inovasyon projeleri.',
  'yapayze': 'Yapay zeka ve makine öğrenmesi platformu. AI teknolojileri, deep learning ve veri bilimi. Yapay zeka uygulamaları ve gelecek trendleri.',

  // Sosyal Sorumluluk
  'gonullu': 'Gönüllülük ve sosyal sorumluluk platformu. Yardım organizasyonları, sosyal projeler ve toplum hizmeti. Gönüllü çalışma fırsatları.',
  'cevreci': 'Çevre dostu yaşam ve sürdürülebilirlik platformu. Geri dönüşüm, enerji tasarrufu ve yeşil teknolojiler. Çevre koruma projeleri.',

  // Yaratıcılık ve Tasarım
  'grafik': 'Grafik tasarım ve görsel sanatlar platformu. Logo tasarımı, web tasarım ve dijital sanat. Tasarım yazılımları ve yaratıcı projeler.',
  'fotograf': 'Fotoğrafçılık sanatı ve teknik rehberler. Kamera incelemeleri, çekim teknikleri ve fotoğraf editörlüğü. Profesyonel fotoğrafçılık ipuçları.',

  // Kişisel Gelişim
  'motivasyon': 'Kişisel gelişim ve motivasyon platformu. Başarı hikayeleri, hedef belirleme ve yaşam koçluğu. Pozitif düşünce ve kişisel dönüşüm.',
  'meditasyon': 'Meditasyon ve mindfulness platformu. Nefes teknikleri, yoga ve ruhsal gelişim. Stres yönetimi ve iç huzur arayışı.',

  // Aile ve İlişkiler
  'evlilik': 'Evlilik ve aile yaşamı platformu. İlişki tavsiyeleri, evlilik hazırlığı ve aile danışmanlığı. Çift terapisi ve iletişim teknikleri.',
  'cocuk': 'Çocuk gelişimi ve ebeveynlik platformu. Çocuk psikolojisi, eğitim yöntemleri ve aile içi iletişim. Bebek bakımı ve çocuk sağlığı.',

  // Yaşlılık ve Sağlık
  'yaslilik': 'Yaşlılık dönemi ve sağlıklı yaşlanma platformu. Yaşlı bakımı, sağlık önerileri ve sosyal aktiviteler. Emeklilik planlaması ve yaşam kalitesi.',
  'rehabilitasyon': 'Rehabilitasyon ve fizik tedavi platformu. Fizik tedavi egzersizleri, yaralanma sonrası iyileşme ve hareket terapisi.',

  // Engelli Hakları
  'engelli': 'Engelli hakları ve erişilebilirlik platformu. Engelli bireylerin toplumsal katılımı, erişilebilir tasarım ve destek hizmetleri.',
  'isaret': 'İşaret dili ve işitme engelliler platformu. İşaret dili öğrenme, işitme cihazları ve işitme engelliler topluluğu.',

  // Göç ve Diaspora
  'goc': 'Göç deneyimleri ve diaspora topluluğu. Yurt dışında yaşam, vize süreçleri ve kültürel adaptasyon. Göçmen hakları ve entegrasyon.',
  'yurtdisi': 'Yurt dışında yaşam ve çalışma platformu. İş bulma, eğitim fırsatları ve yasal süreçler. Expat deneyimleri ve kültürlerarası yaşam.',

  // Kadın ve Toplumsal Cinsiyet
  'kadin': 'Kadın hakları ve toplumsal cinsiyet platformu. Kadın girişimciliği, kariyer gelişimi ve toplumsal eşitlik. Kadın dayanışması ve güçlendirme.',
  'feminist': 'Feminizm ve cinsiyet eşitliği platformu. Feminist teori, kadın hakları mücadelesi ve toplumsal cinsiyet adaleti.',

  // LGBTI+ ve Çeşitlilik
  'lgbti': 'LGBTI+ hakları ve çeşitlilik platformu. Cinsel yönelim, cinsiyet kimliği ve LGBTI+ toplum hakları. Eşitlik mücadelesi ve sosyal kabul.',
  'cesitlilik': 'Çeşitlilik ve kapsayıcılık platformu. Kültürel çeşitlilik, etnik gruplar ve toplumsal uyum. Çokkültürlülük ve hoşgörü.',

  // Barış ve Çatışma Çözümü
  'baris': 'Barış çalışmaları ve çatışma çözümü platformu. Barış eğitimi, arabuluculuk ve toplumsal uzlaşma. Şiddet önleme ve barışçıl çözümler.',
  'insan': 'İnsan hakları ve demokrasi platformu. Temel haklar, özgürlükler ve demokratik katılım. İnsan hakları savunuculuğu ve sivil toplum.',

  // Teknoloji Etiği
  'dijital': 'Dijital etik ve teknoloji felsefesi platformu. Yapay zeka etiği, veri gizliliği ve dijital haklar. Teknolojinin toplumsal etkileri.',
  'siber': 'Siber güvenlik ve dijital güvenlik platformu. Veri koruma, siber saldırılar ve güvenlik önlemleri. Dijital okuryazarlık ve güvenli internet.',

  // Gelecek ve İnovasyon
  'gelecek': 'Gelecek çalışmaları ve trend analizi platformu. Teknolojik gelişmeler, toplumsal değişim ve gelecek senaryoları. İnovasyon ve dönüşüm.',
  'inovasyon': 'İnovasyon ve yaratıcılık platformu. Yenilikçi fikirler, buluşlar ve teknolojik gelişmeler. Ar-Ge projeleri ve patent süreçleri.'
};

export type ForumDescriptionUpdateResult = {
  total: number;
  updated: number;
  unchanged: number;
  failed: number;
};

// Forum açıklamalarını güncelleme fonksiyonu
export async function updateAllForumDescriptions(): Promise<ForumDescriptionUpdateResult> {
  const result: ForumDescriptionUpdateResult = {
    total: 0,
    updated: 0,
    unchanged: 0,
    failed: 0,
  };

  try {
    console.log('Forum açıklamaları güncelleniyor...');

    const { data: forums, error: fetchError } = await supabase
      .from('forums')
      .select('id, forum_id, name, category, members_count, posts_count, topics_count, description');

    if (fetchError) {
      console.error('Forumlar çekilirken hata:', fetchError);
      throw new Error(fetchError.message);
    }

    if (!forums || forums.length === 0) {
      console.log('Güncellenecek forum bulunamadı');
      return result;
    }

    result.total = forums.length;
    console.log(`${forums.length} forum bulundu, açıklamalar güncelleniyor...`);

    for (const forum of forums) {
      try {
        const description = resolveForumDescription(forum);

        if (forum.description === description) {
          result.unchanged++;
          continue;
        }

        const { error: updateError } = await supabase
          .from('forums')
          .update({ description })
          .eq('id', forum.id);

        if (updateError) {
          console.error(`${forum.name} güncellenirken hata:`, updateError);
          result.failed++;
          continue;
        }

        result.updated++;
        console.log(`✅ ${forum.name} güncellendi`);

        await new Promise((resolve) => setTimeout(resolve, 100));
      } catch (error) {
        console.error(`${forum.name} işlenirken hata:`, error);
        result.failed++;
      }
    }

    console.log('\n📊 Güncelleme tamamlandı:');
    console.log(`✅ Güncellenen: ${result.updated}`);
    console.log(`⏭️ Değişmeyen: ${result.unchanged}`);
    console.log(`❌ Hatalı: ${result.failed}`);
    console.log(`📝 Toplam: ${result.total}`);

    return result;
  } catch (error) {
    console.error('Genel hata:', error);
    throw error;
  }
}

/** Tek forum için SEO açıklaması üret (özel sözlük veya otomatik şablon) */
export function resolveForumDescription(forum: {
  forum_id: string;
  name: string;
  category?: string | null;
  members_count?: number | null;
  posts_count?: number | null;
  topics_count?: number | null;
}): string {
  const custom = forumDescriptions[forum.forum_id.toLowerCase()];
  if (custom) return custom;
  return generateAutoDescription(forum);
}

// Tek forum açıklaması güncelleme
export async function updateSingleForumDescription(forumId: string, description: string) {
  try {
    const { error } = await supabase
      .from('forums')
      .update({ description })
      .eq('forum_id', forumId);

    if (error) {
      console.error('Forum açıklaması güncellenirken hata:', error);
      return false;
    }

    console.log(`✅ ${forumId} forum açıklaması güncellendi`);
    return true;
  } catch (error) {
    console.error('Hata:', error);
    return false;
  }
}